import React, { useContext, forwardRef, useImperativeHandle } from 'react';
import { Select, Popover } from 'antd';
import useCopyFormHotelSelectorHook from './CopyFormHotelSelector.hook';
import { AppContext } from 'App.context';

const CopyFormHotelSelector = forwardRef(
  ({ fixedHotel = false, onHotelSelected, isLoading = false, customStyles = {} }, ref) => {
    const {
      appActions: { translate },
    } = useContext(AppContext);
    const { state, actions } = useCopyFormHotelSelectorHook(onHotelSelected);

    useImperativeHandle(ref, () => ({ actions, state }), [actions, state]);

    return (
      <Select
        mode="multiple"
        allowClear={true}
        style={{ width: '100%', ...customStyles }}
        value={state.selectedHotels}
        optionFilterProp="children"
        disabled={isLoading}
        placeholder={translate('hotelSelector.info')}
        onSelect={actions.onSelectNewHotel}
        onDeselect={actions.onDeselectNewHotel}
      >
        {state.compatibleHotelList.length > 0 && (
          <Select.OptGroup key="compatible" label={translate('formCopyCompatibility.compatible')}>
            {state.compatibleHotelList.map(hotel => (
              <Select.Option
                key={hotel.id === null ? 'null' : hotel.id}
                value={hotel.id === null ? 'null' : hotel.id}
                disabled={hotel.id === fixedHotel || isLoading}
              >
                {hotel.compatibility ? (
                  <Popover
                    content={translate('formCopyCompatibility.' + hotel.compatibility)}
                    zIndex={9999}
                  >
                    ⚠️ {hotel.name}
                  </Popover>
                ) : (
                  <span>{hotel.name}</span>
                )}
              </Select.Option>
            ))}
          </Select.OptGroup>
        )}
        {state.uncompatibleHotelList.length > 0 && (
          <Select.OptGroup
            key="incompatible"
            label={translate('formCopyCompatibility.notCompatible')}
          >
            {state.uncompatibleHotelList.map(hotel => (
              <Select.Option
                key={hotel.id === null ? 'null' : hotel.id}
                value={hotel.id === null ? 'null' : hotel.id}
                disabled={true}
              >
                <Popover
                  content={translate('formCopyCompatibility.' + hotel.compatibility)}
                  zIndex={9999}
                >
                  {hotel.name}
                </Popover>
              </Select.Option>
            ))}
          </Select.OptGroup>
        )}
      </Select>
    );
  }
);

export default CopyFormHotelSelector;
